<template>
  <div class="vehicle-animation">
    <div class="exhaust-container">
      <div class="exhaust-puff puff-1"></div>
      <div class="exhaust-puff puff-2"></div>
      <div class="exhaust-puff puff-3"></div>
    </div>
    <div class="vehicle-icon">
      <svg viewBox="0 0 72 32" width="54" height="24">
        <!-- main body - low floor shuttle bus style -->
        <path d="M 4 22 L 4 10 Q 4 7, 8 7 L 58 7 Q 64 7, 66 12 L 66 22 Z" fill="#1e5799"/>
        <!-- roof -->
        <path d="M 8 7 Q 4 7, 4 10 L 4 8 Q 4 6, 8 6 L 58 6 Q 63 6, 65 10 L 64 12 Q 64 8, 58 7 L 8 7" fill="#2a6db5"/>
        <!-- destination sign area -->
        <rect x="10" y="7" width="20" height="4" rx="1" fill="#222"/>
        <rect x="12" y="8" width="16" height="2" rx="0.5" fill="#ff6600"/>
        <!-- large passenger windows -->
        <rect x="6" y="10" width="10" height="8" rx="1" fill="#87ceeb"/>
        <rect x="18" y="10" width="10" height="8" rx="1" fill="#87ceeb"/>
        <rect x="30" y="10" width="10" height="8" rx="1" fill="#87ceeb"/>
        <rect x="42" y="10" width="8" height="8" rx="1" fill="#87ceeb"/>
        <!-- front windshield (large, angled) -->
        <path d="M 52 10 L 58 7 Q 64 7, 66 12 L 66 18 L 52 18 Z" fill="#87ceeb"/>
        <!-- entry door indication -->
        <rect x="16" y="10" width="1" height="12" fill="#333"/>
        <!-- wheel wells -->
        <path d="M 8 22 Q 8 19, 14 19 Q 20 19, 20 22" fill="#152d4a"/>
        <path d="M 48 22 Q 48 19, 54 19 Q 60 19, 60 22" fill="#152d4a"/>
        <!-- wheels -->
        <circle cx="14" cy="24" r="5" fill="#222"/>
        <circle cx="14" cy="24" r="3" fill="#444"/>
        <circle cx="14" cy="24" r="1" fill="#666"/>
        <circle cx="54" cy="24" r="5" fill="#222"/>
        <circle cx="54" cy="24" r="3" fill="#444"/>
        <circle cx="54" cy="24" r="1" fill="#666"/>
        <!-- headlights -->
        <rect x="64" y="14" width="2" height="3" rx="1" fill="#ffdd00"/>
        <!-- taillights -->
        <rect x="4" y="14" width="2" height="3" rx="1" fill="#cc0000"/>
        <!-- side mirror -->
        <rect x="64" y="9" width="3" height="2" rx="0.5" fill="#333"/>
        <!-- stripe detail -->
        <rect x="4" y="19" width="62" height="1" fill="#ff6600"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShuttleAnimation'
}
</script>

<style scoped>
.vehicle-animation {
  display: flex;
  align-items: center;
}

.exhaust-container {
  position: relative;
  width: 0px;
  height: 24px;
  margin-left: 20px;
}

.exhaust-puff {
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #999;
  border-radius: 50%;
  opacity: 0;
  right: 0;
}

.puff-1 {
  bottom: 4px;
  animation: puff-float 1.2s ease-out infinite;
}

.puff-2 {
  bottom: 8px;
  animation: puff-float 1.2s ease-out infinite 0.4s;
}

.puff-3 {
  bottom: 12px;
  animation: puff-float 1.2s ease-out infinite 0.8s;
}

.vehicle-icon {
  animation: vehicle-bounce 0.5s ease-in-out infinite;
}

@keyframes vehicle-bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-2px); }
}

@keyframes puff-float {
  0% {
    opacity: 0.7;
    transform: translateX(0) scale(0.5);
  }
  100% {
    opacity: 0;
    transform: translateX(-15px) scale(1.2);
  }
}
</style>
